const languages = {
    pt: {
        titles: {
            aboutMe: 'Sobre mim',
            projects: 'Projetos',
            skills: 'Habilidades',
            contact: 'Contato'
        },
        titleDescriptions: {
            aboutMe: 'Quem é efilipex? 🤔',
            projects: 'Aqui estão alguns de meus projetos! Vamos ver.',
            skills: 'Ferramentas que uso',
            contact: 'Entre em contanto!'
        },
        showCaseAboutDescription: 'Olá! Estou muito feliz por você estar aqui 😁. Eu sou Emanuel Filipe - ou também chamado efilipex - e sou um estudante de desenvolvimento frontend, em busca de novos conhecimentos e habilidades! Atualmente estou aprendendo ReactJs, React Native, Node, Svelte, Typescript e Python.',
        contactLinks: {
            gb: 'Me siga no Github 💻',
            lk: 'Visite meu LinkedIn 🔗',
            em: 'Me mande um email 📩',
            co: 'Me compraria um café? ☕'
        }
    },
    en: {
        titles: {
            aboutMe: 'About me',
            projects: 'Projects',
            skills: 'Skills',
            contact: 'Contact'
        },
        titleDescriptions: {
            aboutMe: 'Who is efilipex   ? 🤔',
            projects: "Here are some of the projects I build on my own! Let's check it out.",
            skills: 'Tools I can use',
            contact: "Let's keep in touch!"
        },
        showCaseAboutDescription: "Hello! Super glad you're here 😁. I'm Emanuel Filipe - or also called efilipex - and I'm a frontend development student, seeking new knowledges and skills! I'm currently learning ReactJs, React Native, Node, Svelte, Typescript and Python.",
        contactLinks: {
            gb: 'Follow me on Github 💻',
            lk: 'Visit my LinkedIn 🔗',
            em: 'Email me 📩',
            co: 'Would you buy me a coffee? ☕'
        }
    },
    fr: {
        titles: {
            aboutMe: 'Sur moi',
            projects: 'Projects',
            skills: 'Compétences',
            contact: 'Contact'
        },
        titleDescriptions: {
            aboutMe: 'Qui est efilipex? 🤔',
            projects: "Ici vous avez quelques projects que j'ai construit.",
            skills: 'Je peux utiliser ces langages et frameworks',
            contact: "Contatez-moi"
        },
        showCaseAboutDescription: "Salut! Très content d'avoir vous dans mon website 😁. Je m'appelle Emanuel Filipe - ou aussi efilipex - et je suis un frontend development student, en trouvant connaissance! En train d'apprendre ReactJs, React Native, Node, Svelte, Typescript et Python.",
        contactLinks: {
            gb: 'Suivrez-moi sur Github 💻',
            lk: 'Visitez mon LinkedIn 🔗',
            em: 'Envoyez un email 📩',
            co: 'Achetez-moi un café? ☕'
        }
    },
    la: {
        titles: {
            aboutMe: 'De me',
            projects: 'Acta',
            skills: 'Habilitates',
            contact: 'Vincula'
        },
        titleDescriptions: {
            aboutMe: 'Quis est efilipex? 🤔',
            projects: "Hic sunt aliqua acta mea quae ipse feci.",
            skills: 'Ferramenta quibus uti possum',
            contact: "Appella me"
        },
        showCaseAboutDescription: "Salve! Permultum felix sum propter visitationem tuam ad meum vinculum virtuale 😁. Vocor Emmanuel Philippus - aut quoque efilipex - et sum discipulus novorum ferramentorum ad interfacies personarum faciendum, discens ReactJs, React Native, Node, Svelte, Typescript et Python.",
        contactLinks: {
            gb: 'Sequere me in Github 💻',
            lk: 'Visita LinkedIn 🔗',
            em: 'Mitte mihi epistulam virtualem 📩',
            co: 'Eme mihi potus? ☕'
        }
    },
    // gr: {}
};

export default languages;